import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Card } from 'react-native-paper';
// Common components
import { inputRowOperatorStyle, LabeledField } from '../components/LabeledField';
import { TEXT_FIELD_WIDTH } from '../components/consts';
import { HEIGHT_DISPLAY_PLACEHOLDER } from '../utils/heightUnits';
import { styles } from './ProfileViewStyle';
import { FormCard } from './FormCard';
import { useIsNarrowForm } from './ResponsiveFormContext';
import { DescLabels, getLabel } from './formValuesModel';
export const QuestionaireCard = ({ values, readOnly }) => {
    const narrow = useIsNarrowForm();
    return (<FormCard>
      <Card.Content>
        <LabeledField name="outcomeDesc" label={getLabel('outcomeDesc', DescLabels) || ''} width={TEXT_FIELD_WIDTH} height={100} multiline={true} readOnly={readOnly}/>
        <View style={[styles.row, localStyles.weightsRow]}>
          <View style={localStyles.weightGroup}>
            <LabeledField required name="existingWeight" label={`What is your
existing weight?`} width={50} keyboardType="numeric" readOnly={readOnly} signupInput={{ keyboardType: 'decimal-pad' }}/>
            <View style={localStyles.weightOperator}>
              <Text style={localStyles.totalWeight}>-</Text>
            </View>
            <LabeledField required name="idealWeight" label={`What is your
ideal weight?`} width={50} keyboardType="numeric" readOnly={readOnly} signupInput={{ keyboardType: 'decimal-pad' }}/>
            <View style={localStyles.weightOperator}>
              <Text style={localStyles.totalWeight}>{`=   ${(values.existingWeight - values.idealWeight).toFixed(1)}`}</Text>
            </View>
          </View>
          <View style={narrow ? localStyles.heightGroupNarrow : localStyles.heightGroup}>
            <LabeledField required name="heightDisplay" label={`What is your
height?`} placeholder={readOnly ? undefined : HEIGHT_DISPLAY_PLACEHOLDER} width={55} readOnly={readOnly}/>
          </View>
        </View>
        <View style={styles.row}>
          <LabeledField name="weightToLoseDesc" label={getLabel('weightToLoseDesc', DescLabels) || ''} width={TEXT_FIELD_WIDTH} height={50} multiline={true} readOnly={readOnly}/>
        </View>
        <LabeledField name="restrictionsDesc" label={getLabel('restrictionsDesc', DescLabels) || ''} placeholder="(vegetarian, vegan, pescatarian, no seafood, no diary, gluten free, etc.)" width={TEXT_FIELD_WIDTH} height={50} multiline={true} readOnly={readOnly}/>
        <LabeledField name="currentDietDesc" label={getLabel('currentDietDesc', DescLabels) || ''} placeholder="Describe it" width={TEXT_FIELD_WIDTH} height={100} multiline={true} readOnly={readOnly}/>
      </Card.Content>
    </FormCard>);
};
const localStyles = StyleSheet.create({
    weightsRow: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        gap: 8,
    },
    weightGroup: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        gap: 8,
    },
    heightGroup: {
        marginLeft: 40,
    },
    // Phone-sized public sign-up: height wraps under the weights.
    heightGroupNarrow: {
        marginLeft: 0,
    },
    weightOperator: inputRowOperatorStyle(),
    totalWeight: {
        fontStyle: 'italic',
    },
});
